(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CardPrefixConfigDetailController', CardPrefixConfigDetailController);

    CardPrefixConfigDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CardPrefixConfig'];

    function CardPrefixConfigDetailController($scope, $rootScope, $stateParams, previousState, entity, CardPrefixConfig) {
        var vm = this;

        vm.cardPrefixConfig = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:cardPrefixConfigUpdate', function(event, result) {
            vm.cardPrefixConfig = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
